<ui-table
  [title]="'translate.order.emails'"
  [isWrapped]="true"
  [dense]="true"
  [data]="order.orderEmails"
  [rowHover]="false"
  [showPaginator]="false"
  [topEnd]="newEmailLink"
  (onRowSelect)="onRowSelect($event)"
  [templates]="[
    {
      title: 'translate.general.created',
      template: crDate
    },
    {
      title: 'translate.general.templateDescr',
      template: templateDescr
    },
    {
      title: 'translate.order.emails.body',
      template: body
    },
    {
      title: 'translate.general.status',
      template: status
    }
  ]"
></ui-table>

<ng-template #templateDescr let-row="row">
  {{ row.templateDescr }}
</ng-template>

<ng-template #crDate let-row="row">
  {{ row.crDate | date : "dd/MM/yy" }}
</ng-template>

<ng-template #status let-row="row">
  {{ "translate.order.emails.status." + row.status | translate }}
</ng-template>

<ng-template #body let-row="row">
  <span class="text-preview">{{ row.body }}</span>
</ng-template>

<ng-template #newEmailLink>
  <a (click)="createEmail()" class="note"
    >+ {{ "translate.order.emails.new" | translate }}</a
  >
</ng-template>

<modal-popup
  *ngIf="displayEdit && selectedEmail"
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayEdit = false"
  [isOpen]="displayEdit"
>
  <edit-order-email
    [email]="selectedEmail"
    (onCancel)="displayEdit = false; selectedEmail = null"
    (onSave)="onSaveEmail()"
  ></edit-order-email>
</modal-popup>
